import accessibility from '../modules/accessibility';
import cookie from '../modules/cookie';
import navbar from '../modules/navbar';
import nav from '../modules/nav';
import modal from '../modules/modal';
import widget from '../modules/widget';
import form from '../modules/form';
import qtyInput from '../modules/product-quantity-change';
import checkoutTabs from '../modules/checkout-tabs';
import cartCouponForm from '../modules/cart-show-coupon-field';
import refreshFragments from '../modules/checkout-refresh-fragments';
import garanLabel from '../modules/garan-label';


export default {
  init() {
    accessibility.init();
    cookie.init();
    navbar.init();
    nav.init();
    modal.init();
    widget.init();
    form.init();
    qtyInput.init();
    checkoutTabs.init();
    cartCouponForm.init();
    refreshFragments.init();
    garanLabel.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js